module.exports = __webpack_public_path__ + "img/member3.227aa92e.png";